<p class="text-sm text-neutral-600">{{ versionName }} - {{ version }}</p>
